module.exports = "<svg viewBox=\"0 0 34.6 40\"><path d=\"M26.9 20L3.9 6.7v26.5l23-13.2z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/play.svg
// module id = 304
// module chunks = 1